import { API_URL, ASSETS, URL, PLATFORM_FEE } from '../config.js';
import View from './View';

class SingleOrderView extends View {
  _parentElement = document.querySelector('.main');
  _errorMessage = 'Single Order View Error Message';
  _message = 'Single Order View Success Message';

  addHandlerSaveAddress(handler) {
    const paymentForm = document.querySelector('.cart__payment--container');
    if (!paymentForm) return;

    paymentForm.addEventListener('submit', e => {
      e.preventDefault();
      e.stopImmediatePropagation();
      // const formData = new FormData(this);
      // formData.append(
      //   'size',
      //   document.querySelector('.product__size--btn-selected').data.set.size,
      // );
      // const data = Object.fromEntries([...formData]);

      const dataArr = [...new FormData(paymentForm)];
      const data = Object.fromEntries(dataArr);
      data.size = document.querySelector(
        '.product__size--btn-selected',
      ).dataset.size;
      
      
      handler(data);
      
    });
  }

  _generateMarkup() {
    const product = this._data;
    
    const requireIf = prop => (prop ? `required` : ``);

    `
          <div class="product__size--button">
            <button
              class="product__size--btn product__size--btn-selected orderlist__size"
              data-size="${product.size}"
            >
              ${product.size}
            </button>
          </div>
    
    `;
    return `
          <div class="row cart">
        <div class="cart__head">
          <h2 class="cart__heading">Shipping Address</h2>
        </div>



        <!-- MANAGING CART ADDRESS AND PAYMENT -->
        <form action="#" class="cart__payment--container">
          <!-- SHIPPING ADDRESS -->
          <div class="cart__payment--address">
            <div class="cart__items--container-single">
              <ul class="cart__items">
                <li class="cart__item">

                  <a href="/product?${product.slug}" class="link">
                    <div class="cart__item--img">
                      <img
                        src="${ASSETS}images/product/${product.imageCover}"
                        alt="${product.tag}"
                      />
                    </div>
                  </a>
                  <div class="cart__item--detail">
                    <div class="">
                      <h3 class="cart__item--title">
                        ${product.brand}
                      </h3>
                      <h4 class="cart__item--tag">${product.tag}</h4>
                      <div class="product__size--button">
                        <button
                          class="product__size--btn product__size--btn-selected cart__size"
                          data-size="${product.size}"
                        >
                          ${product.size}
                        </button>
                      </div>
                    </div>

                    <div class="cart__item--price">
                      <span class="cart__item--discounted-price">₹ ${product.price}</span>
                      ${
                        product.mrp && product.mrp - product.price > 0
                          ? `<span class="cart__item--mrp">₹ ${product.mrp}</span> 
                      <span class="cart__item--discount-percent"
                        >(${Math.ceil(((product.mrp - product.price) * 100) / product.mrp)}% OFF)</span
                      >`
                          : ''
                      }
                      
                    </div>
                  </div>
                </li>
              </ul>
            </div>

            <h3 class="cart__payment--heading">Shipping Address</h3>


            ${product.shipAddress ? `<address class="paragraph"><strong>${product.shipAddress}</strong></address>` : ``}

            <div class="label-input">
              <label for="${!product.shipAddress ? `` : `newAddress`}">New Shipping Address </label>
              <input
                type="checkbox"
                id="newAddress"
                name="newAddress"
                value="true"
                class="checkbox__new-ship-add"
                ${!product.shipAddress ? `checked` : ``}
                style="${!product.shipAddress ? `pointer-events: none` : ``}"
              />
            </div>

            
            <div class="cart__payment--lab-in">
              <label for="add-1">Address 1:</label>
              <input
                type="text"
                id="add-1"
                placeholder="your address"
                ${requireIf(!product.shipAddress)}                
                name="add1"
              />
            </div>
            <div class="cart__payment--lab-in">
              <label for="add-2">Address 2:</label>
              <input type="text" id="add-2" placeholder="your address" name="add2"/>
            </div>

            <div class="cart__payment--lab-in-2">
              <div class="cart__payment--lab-in">
                <label for="mobile">Mobile:</label>
                <input
                  type="tel"
                  id="mobile"
                  placeholder="9123456789"
                  maxlength="10"
                  minlength="10"
                  name="mobile"
                  ${requireIf(!product.shipAddress)}  
                />
              </div>
              <div class="cart__payment--lab-in">
                <label for="pin">Postal pin code:</label>
                <input
                  type="text"
                  id="pin"
                  placeholder="your pincode"
                  maxlength="6"
                  minlength="6"
                  name="pin"
                  ${requireIf(!product.shipAddress)}  
                />
              </div>
            </div>

            <div class="cart__payment--lab-in-2">
              <div class="cart__payment--lab-in">
                <label for="city">City/Dist:</label>
                <input type="text" id="city" name="dist" placeholder="Patna"  ${requireIf(!product.shipAddress)}   />
              </div>
              <div class="cart__payment--lab-in">
                <label for="state">State:</label>
                <input type="text" id="state" name="state" placeholder="Bihar"  ${requireIf(!product.shipAddress)}   />
              </div>
            </div>
          </div>

          <!-- AMOUNT DETAILS -->
          <div class="cart__detail">
            <div class="cart__price--container">
              <p class="cart__mrp--total cart__label-value">
                <span class="cart__mrp--total-label cart__label"
                  >Total MRP:</span
                ><span class="cart__mrp--total-value cart__value">₹${product.mrp}</span>
              </p>
              <p class="cart__discount--total cart__label-value">
                <span class="cart__discount--total-label cart__label"
                  >Discount on MRP:</span
                ><span class="cart__discount--total-value cart__value"
                  >${product.mrp - product.price > 0 ? `- ₹${product.mrp - product.price}` : `0`}</span
                >
              </p>
           <!--   
              <p class="cart__platformfee cart__label-value">
                <span class="cart__platformfee-label cart__label"
                  >Platform Fee:</span
                ><span class="cart__platformfee-value cart__value">₹${product.platformFee}</span>
              </p>
              <p class="cart__tax cart__label-value">
                <span class="cart__tax-label cart__label">Tax:</span
                ><span class="cart__tax-value cart__value">₹${product.tax}</span>
              </p>
          -->
              <p class="cart__price--total cart__label-value">
                <span class="cart__price--total-label">Amount:</span
                ><span class="cart__price--total-value"
                  ><strong>₹${product.price}</strong></span
                >
              </p>
            </div>

            <!-- PAYMENT OPTIONS -->

            <div class="cart__payment--options-container">
              <h3 class="product__spec--title cart__payment--method">Select Payment Method</h3>
              <ul class="cart__payment--options">
                <li class="cart__payment--option">
                  <input
                    type="radio"
                    name="paymentOption"
                    value="cod"
                    id="cod"
                    class="cart__payment--option-radio"
                  />
                  <label for="cod">COD</label>
                </li> 
                <li class="cart__payment--option">
                  <input
                    type="radio"
                    name="paymentOption"
                    value="online"
                    id="online"
                    class="cart__payment--option-radio"
                    
                  />
                  <label for="online">UPI/CC/DC/NB</label>
                </li>
              </ul>
            </div>

            <!-- CTA -->
            <div class="cart__cta--container">
              <div class="cart__cta">
                <button type="submit"
                  class="btn btn--cart cart__cta--btn  cart__cta--btn-address"
                >
                  Save & Continue
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    `;
  }
}

export default new SingleOrderView();
